module.exports = __webpack_public_path__ + "static/thorass-dethek-espruar-alphabet-cotr_1ed-d2fa133b73fc1bfa8d108d72d9598d18.jpg";